export default __webpack_public_path__ + "static/media/Ardian-Mehmeti.c89b4f9d.png";